import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import {
  OpenCustomerInstructionData,
  openCustomerInstructionSchema,
} from "../OpenCustomerInstructionForm.schema";

export function useOpenCustomerInstructionForm() {
  return useForm<OpenCustomerInstructionData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(openCustomerInstructionSchema) as any,
    defaultValues: {
      header: "",
      main: "",
    },
  });
}
